/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { Action, ReduxState } from '../types';

export type DocumentsActionType = 'SET_CURRENT_DOC' | 'SET_SELECTED_DOC' | 'SET_DOCUMENTS';

const initialState: ReduxState['document'] = {
  currentDoc: undefined,
  documents: [],
  selectedDoc: undefined,
};

export default function documentReducer(state = initialState, action: Action) {
  switch (action.type) {
    case 'SET_CURRENT_DOC':
      return {
        ...state,
        currentDoc: action.payload,
      };
    case 'SET_DOCUMENTS':
      return {
        ...state,
        documents: [...action.payload],
      };
    case 'SET_SELECTED_DOC':
      return {
        ...state,
        selectedDoc: action.payload,
      };
    default:
      return state;
  }
}
